import React from 'react';
import UserPerformanceReport from './UserPerformanceReport';
import LeaveReport from './LeaveReport';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <UserPerformanceReport />
      <br />
      <LeaveReport />
    </div>
  );
};

export default Dashboard;
